import Swiper from 'swiper';

window.onload = function () {
  var swiper = new Swiper('.swiper-container', {
    spaceBetween: 30,
    speed: 600,
    crossFade: true,
    effect: 'fade',
    lazy: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });
}


// WEBPACK FOOTER //
// ./resources/assets/js/slider.js